
export function Converter({ data, converterName, deep = Infinity, skips = [] }) {
  const converts = ['camelcase', 'snakecase']
  if (!converts.includes(converterName))
    throw `Must pass a convertName valid. EX.: [${converts.join(', ')}]`

  if (deep && !Number.isInteger && !Number.isInteger(deep))
    throw 'Must pass a deep as Integer'

  const hashFunction = {
    camelcase: (key) => key.replace(/(_\w)/g, (k) => k[1].toUpperCase()),
    snakecase: (key) => key.replace(/[\w]([A-Z])/g, (m) => m[0] + '_' + m[1]).toLowerCase()
  }

  const preParse = (data, callback, limit) => {
    if (data && typeof data === 'object') {
      let newData = JSON.parse(JSON.stringify(data))
      recursive(newData, callback, limit)
      return newData
    } else if (typeof data == 'string') {
      return callback(data)
    }
  }

  const recursive = (data, callback, limit) => {
    if (limit < 0)
      return

    if (Array.isArray(data))
      data.forEach(d => recursive(d, callback, limit - 1))
    else if (data && typeof data == 'object') {
      Object.entries(data).forEach(([key, value]) => {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(key)) {
          let newKey = callback(key)
          if (newKey !== key && !skips.includes(key)) {
            data[newKey] = value
            delete data[key]
          }
          recursive(value, callback, limit - 1)
        }
      })
    }
  }

  this.perform = () => {
    const callback = hashFunction[converterName]

    return preParse(data, callback, deep)
  }
}